export default __webpack_public_path__ + "static/media/GT-Walsheim-Pro-Medium.f8555a33.ttf";